import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom';

// Lazy-loaded route components
const Pages = lazy(() => import('./components/Pages'));
const AboutUs = lazy(() => import('./components/AboutUs'));
const JoinUs = lazy(() => import('./components/JoinUs'));
const BlogsPage = lazy(() => import('./components/Blogs'));
const Products = lazy(() => import('./components/Products'));
const FeaturesPage = lazy(() => import('./components/FeaturesPage'));
const ContactPage = lazy(() => import('./contact/page'));
const Help = lazy(() => import('./service/help/page'));
const Privacypolicy = lazy(() => import('./privacypolicy/page'));
const TermsOfService = lazy(() => import('./termsofservices/page'));
const CookiePolicy = lazy(() => import('./cookiepolicy/page'));
const SafetyCenter = lazy(() => import('./safetycenter/page'));
const ChildSafetyStandards = lazy(() => import('./childsafetystandards/page'));
const CommunityGuidelines = lazy(() => import('./communityguidelines/page'));
const CopyrightPolicy = lazy(() => import('./copyrightpolicy/page'));
const ShareRedirect = lazy(() => import('./components/ShareRedirect'));
const StoryShareRedirect = lazy(() => import('./components/StoryShareRedirect'));
const JoinRedirect = lazy(() => import('./components/JoinRedirect'));
const NotFound = lazy(() => import('./components/NotFound'));

const appRouter = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <Pages />,
      },
      {
        path: '/aboutus',
        element: <AboutUs />,
      },
      {
        path: '/joinus',
        element: <JoinUs />,
      },
      {
        path: '/blogs',
        element: <BlogsPage />,
      },
      {
        path: '/business',
        element: <Products />,
      },
      {
        path: '/legal/privacy-policy',
        element: <Privacypolicy />,
      },
      {
        path: '/legal/terms-of-service',
        element: <TermsOfService />,
      },
      {
        path: '/legal/copyright-policy',
        element: <CopyrightPolicy />,
      },
      {
        path: '/legal/cookie-policy',
        element: <CookiePolicy />,
      },
      {
        path: '/legal/safety-center',
        element: <SafetyCenter />,
      },
      {
        path: '/legal/child-safety-standards',
        element: <ChildSafetyStandards />,
      },
      // Redirects from old slugs
      {
        path: '/privacy',
        element: <Navigate to="/legal/privacy-policy" replace />,
      },
      {
        path: '/privacypolicy',
        element: <Navigate to="/legal/privacy-policy" replace />,
      },
      {
        path: '/cookies',
        element: <Navigate to="/legal/cookie-policy" replace />,
      },
      {
        path: '/safety',
        element: <Navigate to="/legal/safety-center" replace />,
      },
      {
        path: '/child-safety',
        element: <Navigate to="/legal/child-safety-standards" replace />,
      },
      {
        path: '/community-guidelines',
        element: <CommunityGuidelines />,
      },
      {
        path: '/contact',
        element: <ContactPage />,
      },
      {
        path: '/help',
        element: <Help />,
      },
      {
        path: '/terms',
        element: <Navigate to="/legal/terms-of-service" replace />,
      },
      {
        path: '/features',
        element: <FeaturesPage />,
      },
      {
        path: '/copyright',
        element: <Navigate to="/legal/copyright-policy" replace />,
      },
      {
        path: '/p/:shareCode',
        element: <ShareRedirect />,
      },
      {
        path: '/s/:shareCode',
        element: <StoryShareRedirect />,
      },
      {
        path: '/join',
        element: <JoinRedirect />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <RouterProvider router={appRouter} />
    </HelmetProvider>
  </React.StrictMode>
);
